export default __webpack_public_path__ + "static/media/temper.865cf909.jpg";